module.exports = __webpack_public_path__ + "static/media/research.40fe3008.svg";